import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import Spin from '../../../components/loading';
import FailedMessagesList from '../../../components/failedMesasgesList';
import ImageUploader from '../../../components/imageUploader';
import * as adActions from '../../../redux/ads/actions';
import { validator, formatter } from '../../../utils';
import DatePicker from './../../../components/FormElements/DatePicker/DatePicker';
import jmoment from 'moment-jalaali';
import Select from 'react-select';

import * as cafeActions from '../../../redux/cafes/actions';

class AddOrEditAd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      imageFileName: '',
      imageUrl: '',
      imageFileNameInputError: '',
      delayTime: 3,
      displayOrder: '',
      linkUrl: '',
      linkUrlInputError: '',
      startDate: '',
      endDate: '',
      cafeId: null
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    this.props.actions.getAllCafeNamesForPanel();
    if (
      this.props.location.pathname === '/ads/edit' &&
      !(this.props.editMode && this.props.location && this.props.location.adId)
    ) {
      return this.props.history.push('/ads');
    } else if (this.props.location.pathname === '/ads/edit') {
      // this.props.actions.getAdById(this.props.location.adId);
    }
  }

  saveForm = async event => {
    console.log('save form');

    const isFormValid = await this.validateForm();
    console.log('form is valid? ', isFormValid);
    if (!isFormValid) {
      return;
    }

    const imageFileName = this.state.imageFileName;
    const adUrl = this.state.adUrl;
    const displayOrder = this.state.displayOrder;
    const delayTime = this.state.delayTime;
    const validFrom = jmoment(this.state.startDate, 'YYYY-MM-DD').format('jYYYY/jMM/jDD');
    const validTo = jmoment(this.state.endDate, 'YYYY-MM-DD').format('jYYYY/jMM/jDD');
    const cafeId = this.state.cafeId;

    const ad = {
      imageFileName,
      adUrl,
      displayOrder,
      delayTime,
      validFrom,
      validTo,
      cafeId
    };

    if (this.props.editMode === true) {
    } else {
      this.props.actions
        .addAd(ad)
        .then(() => {
          // todo: show message
          this.props.history.push('/ads');
        })
        .catch(console.error);
    }
  };

  validateForm = () => {
    return new Promise(resolve => {
      const standardLinkUrl = formatter.toStandard(this.state.linkUrl);
      let isLinkUrlValid = false;
      let isImageFileValid = false;
      let errors = {};

      if (standardLinkUrl && !validator.isWebsiteUrl(standardLinkUrl)) {
        isLinkUrlValid = false;
        errors.linkUrlInputError = locales('messages.fieldValueIsInvalid', {
          fieldName: locales('fields.ad.link.url'),
          fieldValue: ''
        });
      } else {
        isLinkUrlValid = true;
        errors.linkUrlInputError = '';
      }

      if (!this.state.imageFileName) {
        isImageFileValid = false;
        errors.imageFileNameInputError = locales('messages.selectValueForFieldIsMandatory', {
          fieldName: locales('fields.ad.image')
        });
      } else {
        isImageFileValid = true;
        errors.imageFileNameInputError = '';
      }

      const isFormValid = isLinkUrlValid && isImageFileValid;

      if (!isFormValid) {
        this.setState(
          () => ({
            ...errors
          }),
          () => {
            resolve(false);
          }
        );
      } else {
        resolve(true);
      }
    });
  };

  onUploadAdImageSuccess = uploadedImage => {
    this.setState(() => ({
      imageFileName: uploadedImage.fileName,
      imageUrl: uploadedImage.url,
      imageFileNameInputError: ''
    }));
  };

  deleteAdImage = param => {
    this.setState(() => ({
      imageFileName: null,
      imageUrl: null,
      imageFileNameInputError: ''
    }));
  };

  onChangeDelayTime = event => {
    const delayTime = event.target.value;

    if (!delayTime || (validator.isNumber(delayTime) && delayTime <= 10)) {
      this.setState(() => ({
        delayTime
      }));
    }
  };

  onChangeDisplayOrder = event => {
    const displayOrder = event.target.value;

    if (!displayOrder || (validator.isNumber(displayOrder) && displayOrder <= 32767)) {
      this.setState(() => ({
        displayOrder
      }));
    }
  };

  onChangeLinkUrl = event => {
    const linkUrl = event.target.value;

    if (validator.isWebsiteUrl(linkUrl, { typing: true })) {
      this.setState(() => ({
        linkUrl,
        linkUrlInputError: ''
      }));
    } else {
      this.setState(() => ({
        linkUrlInputError: ''
      }));
    }
  };

  render() {
    return (
      <Spin spinning={this.props.loading} className="col-9 mt-5">
        <section className="page-header">
          <h1>{locales('titles.manage.ads')}</h1>
          <div className="form-actions">
            {!this.props.editMode && (
              <button type="submit" className="btn btn-success w-100" onClick={this.saveForm}>
                <i className="fa fa-save" />
                {locales('labels.save')}
              </button>
            )}
            <Link to="/ads" className="btn btn-default">
              <i className="fa fa-reply"></i>
              {locales('labels.cancel')}
            </Link>
          </div>
        </section>
        <section className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">
              <i className="fa fa-pencil"></i>
              {this.props.editMode ? locales('titles.edit.ad') : locales('titles.add.new.ad')}
            </h3>
          </div>
          <div className="panel-body">
            <form className="col form-horizontal">
              <FailedMessagesList className="errors-list" messagesList={this.props.failedMessages} />
              {this.props.error && (
                <div
                  className={`errors-list ${this.props.className} alert alert-danger alert-dismissible fade show`}
                  role="alert"
                >
                  {locales('messages.server.error')}
                </div>
              )}
              <div className="form-row">
                <div className="form-group required col d-flex">
                  <label className="rsee-form-label">{locales('fields.ad.image')}</label>
                  <div className="full-width">
                    <ImageUploader
                      placeholder={locales('fields.ad.image')}
                      isMulti={false}
                      actionUrl={`${API_ENDPOINT}/v1/general/app/upload-ad`}
                      imageFile={this.state.imageUrl}
                      onUploadSuccess={this.onUploadAdImageSuccess}
                      deleteImage={this.deleteAdImage}
                    />
                    <small className="form-text text-muted">
                      {locales('messages.select.ad.image.helper.text')}
                    </small>
                    <div
                      className={`invalid-feedback ${
                        !!this.state.imageFileNameInputError ? 'is-invalid-feedback' : ''
                      }`}
                    >
                      {this.state.imageFileNameInputError}
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group required col d-flex">
                  <label className="rsee-form-label" htmlFor="delayTime">
                    {locales('fields.ad.delay.time')}
                  </label>
                  <div className="full-width">
                    <input
                      type="text"
                      className="form-control"
                      id="delayTime"
                      autoComplete="off"
                      value={this.state.delayTime}
                      onChange={this.onChangeDelayTime}
                    />
                    <small className="form-text text-muted">
                      {locales('messages.input.delay.time.helper.text')}
                    </small>
                  </div>
                </div>
                <div className="form-group d-flex col">
                  <label className="rsee-form-label" htmlFor="displayOrder">
                    {locales('fields.display.order')}
                  </label>
                  <div className="full-width">
                    <input
                      type="text"
                      className="form-control"
                      id="displayOrder"
                      autoComplete="off"
                      value={this.state.displayOrder}
                      onChange={this.onChangeDisplayOrder}
                    />
                    <small className="form-text text-muted">
                      {locales('messages.input.display.order.helper.text')}
                    </small>
                  </div>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group required col d-flex">
                  از
                  <DatePicker
                    marge={true}
                    placeholder="تاریخ شروع"
                    name="validFrom"
                    className="form-control"
                    value={this.state.startDate}
                    onChange={v => this.setState({ startDate: v })}
                  />
                </div>

                <div className="form-group d-flex col">
                  تا
                  <DatePicker
                    marge={true}
                    placeholder="تاریخ پایان"
                    name="validTo"
                    className="form-control"
                    value={this.state.endDate}
                    onChange={v => this.setState({ endDate: v })}
                  />
                </div>
                <div className="form-group d-flex required col">
                  <label className="rsee-form-label">{locales('fields.cafe.name')}</label>
                  <Select
                    id="cafeId"
                    name="cafeId"
                    initValue={this.state.cafeId}
                    onChange={selectedCafeId => {
                      this.setState({ cafeId: selectedCafeId.value });
                    }}
                    // className={`col-12 p-0 rc-dropdown ${confirmCafeIdNotSelectedStatus}`}
                    className={`col-12 p-0 rc-dropdown`}
                    options={this.props.cafeNamesList.map(n => ({
                      label: n.name,
                      value: n.id
                    }))}
                    placeholder={
                      this.state.cafeId
                        ? this.props.cafeNamesList?.find(item => item.id === this.state.cafeId).name
                        : locales('fields.cafe.name')
                    }
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group col d-flex">
                  <label className="rsee-form-label" htmlFor="linkUrl">
                    {locales('fields.ad.link.url')}
                  </label>
                  <div className="full-width">
                    <input
                      type="text"
                      className={`form-control text-left ${
                        !!this.state.linkUrlInputError ? 'is-invalid' : ''
                      }`}
                      id="linkUrl"
                      autoComplete="off"
                      value={this.state.linkUrl}
                      onChange={this.onChangeLinkUrl}
                    />
                    <small className="form-text text-muted">
                      {locales('messages.input.ad.link.url.helper.text')}
                    </small>
                    <div
                      className={`invalid-feedback ${
                        !!this.state.linkUrlInputError ? 'is-invalid-feedback' : ''
                      }`}
                    >
                      {this.state.linkUrlInputError}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </section>
      </Spin>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.adsReducer.addOrEditAdLoading,
  error: state.adsReducer.addPrEditAdError,
  failed: state.adsReducer.addOrEditAdFailed,
  failedMessages: state.adsReducer.addOrEditAdFailedMessages,

  cafeNamesList: state.cafesReducer.cafeNamesList,
  cafeNamesListLoading: state.cafesReducer.cafeNamesListLoading,
  cafeNamesListFailed: state.cafesReducer.cafeNamesListFailed,
  cafeNamesListMessage: state.cafesReducer.cafeNamesListMessage,
  cafeNamesListError: state.cafesReducer.cafeNamesListError
});

const mapDispatchToProps = dispatch => ({
  actions: {
    addAd: ad => dispatch(adActions.addAd(ad)),
    editAd: ad => dispatch(adActions.editAd(ad)),
    getAllCafeNamesForPanel: () => dispatch(cafeActions.getAllCafeNamesForPanel())
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AddOrEditAd);
